import styles from './footer.module.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import ClearServices from '../../Assets/Images/Logos/ClearServices Logos/ClearServices.png';
import instagram from '../../Assets/Images/Icons/Social/instagram.png';
import facebook from '../../Assets/Images/Icons/Social/facebook.png';
import tiktok from '../../Assets/Images/Icons/Social/tik-tok.png';

const Footer = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const currentPath = location.pathname;

    const isActive = (path) => currentPath === path;

    return (
        <div className={styles.footer}>
            <div className={styles.footerTop}>
                <div className={styles.footerTopLeft}>
                    <h2>Clear Property Management</h2>
                    <p>
                        Can’t find the answer you’re looking for? Please contact with our customer
                        service.
                    </p>
                </div>
                <div className={styles.footerTopRight}>
                    <div>
                        <h3>Company</h3>
                        <h4
                            className={isActive('/about') ? styles.active : ''}
                            onClick={() => navigate('/about')}
                        >
                            About
                        </h4>
                        {/* <h4
                            className={isActive('/properties') ? styles.active : ''}
                            onClick={() => navigate('/properties')}
                        >
                            Properties
                        </h4> */}
                        <h4
                            className={isActive('/services') ? styles.active : ''}
                            onClick={() => navigate('/services')}
                        >
                            Services
                        </h4>
                        <h4
                            className={isActive('/contact') ? styles.active : ''}
                            onClick={() => navigate('/contact')}
                        >
                            Contact
                        </h4>
                        <h4
                            className={isActive('/login') ? styles.active : ''}
                            onClick={() => navigate('/login')}
                        >
                            Login
                        </h4>
                    </div>
                    <div>
                        <h3>Resource</h3>
                        <h4
                            className={isActive('/privacy') ? styles.active : ''}
                            onClick={() => navigate('/privacy')}
                        >
                            Privacy Policy
                        </h4>
                    </div>
                </div>
            </div>
            <div className={styles.footerBottom}>
                <img src={ClearServices} alt='logo' />
                <div className={styles.socialBar}>
                    <div>
                        <h3>Email Now</h3>
                        <h4>contact@clearmanagement.ca</h4>
                    </div>
                    <div>
                        <h3>Phone</h3>
                        <h4>+1 226 600 9243</h4>
                    </div>
                    <div>
                        <h3>Follow Us</h3>
                        <div className={styles.socialLinks}>
                            <a
                                href='/'
                                target='_blank'
                                rel='noreferrer'
                            >
                                <img src={instagram} alt='Instagram' />
                            </a>
                            <a
                                href='/'
                                target='_blank'
                                rel='noreferrer'
                            >
                                <img src={facebook} alt='facebook' />
                            </a>
                            <a
                                href='/'
                                target='_blank'
                                rel='noreferrer'
                            >
                                <img src={tiktok} alt='tiktok' />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <p>© {new Date().getFullYear()} Clear Property Management</p>
        </div>
    );
};

export default Footer;
